export default {"src":"/_next/static/media/enlarge.7c2e016a.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};